import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { lessonStatusMeta } from '../utils/lessonStatus';

function LessonStep({ lesson, isActive, isLast, onSelect }) {
  const meta = lessonStatusMeta[lesson.status];
  const clickable = (
    lesson.status === 'available' || lesson.status === 'in-progress'
  );

  return (
    <div className="lesson-step">
      <div className="lesson-step-rail">
        <span className={`lesson-node ${meta.className}`}>
          <SafeIcon icon={meta.icon} />
        </span>
        {!isLast && <span className="lesson-connector" />}
      </div>

      <button
        className={`lesson-step-card ${isActive ? 'active' : ''}`}
        disabled={!clickable}
        onClick={() => clickable && onSelect(lesson)}
        type="button"
      >
        <div className="lesson-step-top">
          <span className="lesson-order">Lesson {lesson.order}</span>
          <span className={`lesson-status-pill ${meta.className}`}>{meta.label}</span>
        </div>
        <strong>{lesson.title}</strong>
        <p>{lesson.description}</p>
        {lesson.status === 'locked' && (
          <span className="locked-hint">
            <SafeIcon icon={lessonStatusMeta.locked.icon} />
            Complete the previous lesson to unlock
          </span>
        )}
      </button>
    </div>
  );
}

export default LessonStep;